import React from 'react'
import PriceForm from './PriceForm'

const App = () => {
  return (
    <div className="App">
      <PriceForm />
    </div>
  )
}

export default App
